export type ThemeId =
  | 'editorial-luxe'
  | 'moroccan-traditional'
  | 'sereine-pastel'
  | 'caftan-couture-sombre'
  | 'henna-terra'
  | 'bazaar-editorial'
  | 'atlas-modern'
  | 'cinematic-maison';

export interface ThemeMeta {
  id: ThemeId;
  label: string;
  description: string;
}

export const THEMES: ThemeMeta[] = [
  {
    id: 'editorial-luxe',
    label: 'Éditorial · Paris',
    description: 'Magazine couture, ivory & brass, Cormorant + Manrope.',
  },
  {
    id: 'sereine-pastel',
    label: 'Sereine · Pastel',
    description: 'Boutique chic, rose poudré & sauge, Fraunces + DM Sans.',
  },
  {
    id: 'moroccan-traditional',
    label: 'Marocain · Traditionnel',
    description: 'Caftan & zellige, cream & emerald, Cinzel + EB Garamond.',
  },
  {
    id: 'caftan-couture-sombre',
    label: 'Caftan · Couture Sombre',
    description: 'Haute couture nocturne, bourgogne profond & or, Bodoni Moda + Tajawal.',
  },
  {
    id: 'henna-terra',
    label: 'Henné · Terra',
    description: 'Sable & terracotta, henné profond & charbon, Fraunces italique + Lora.',
  },
  {
    id: 'bazaar-editorial',
    label: 'Bazaar · Editorial',
    description: 'Safran & indigo, ivoire mat, Italiana display, esprit Vogue Arabia.',
  },
  {
    id: 'atlas-modern',
    label: 'Atlas · Modern',
    description: 'Argile & indigo, oat, modernist sans + serif editorial, racines Maroc sans folklore.',
  },
  {
    id: 'cinematic-maison',
    label: 'Cinematic · Maison',
    description: 'Noir profond & or pâle, Playfair Display thin + Inter, esprit Dior / Saint Laurent.',
  },
];

export const DEFAULT_THEME: ThemeId = 'cinematic-maison';
export const STORAGE_KEY = 'handcrafted.theme';

export function isThemeId(value: unknown): value is ThemeId {
  return (
    value === 'editorial-luxe' ||
    value === 'moroccan-traditional' ||
    value === 'sereine-pastel' ||
    value === 'caftan-couture-sombre' ||
    value === 'henna-terra' ||
    value === 'bazaar-editorial' ||
    value === 'atlas-modern' ||
    value === 'cinematic-maison'
  );
}

export function readStoredTheme(): ThemeId {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (isThemeId(raw)) return raw;
  } catch {
    // ignore
  }
  return DEFAULT_THEME;
}

export function applyTheme(theme: ThemeId): void {
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}
